import React from "react";
const TransactionRuleComponent = () => {
  return (
    <>
      <p className="title">特定商取引法に基づく表記</p>
      <div className="content-wrapper">
        <dl className="two-column-content">
          <dt>番組名</dt>
          <dd>minera（ミネラ）</dd>
          <dt>社名</dt>
          <dd>株式会社リアズ</dd>
          <dt>所在地</dt>
          <dd>大阪市淀川区西中島5-14-10新大阪トヨタビル4階</dd>
          <dt>サイト責任者</dt>
          <dd>釜野智史</dd>
          <dt>電話番号</dt>
          <dd>06-6307-2223</dd>
          <dt>メールアドレス</dt>
          <dd>minera.fit.2312@gmail.com</dd>
          <dt>お問合せ先</dt>
          <dd>お問い合わせ(9時～18時)</dd>
          <dt>支払方法</dt>
          <dd>
            お支払方法は、以下のいずれかよりお選びいただけます<br />・Googleplay決済
          </dd>
          <dt>支払い時期</dt>
          <dd>前払い制</dd>
          <dt>利用可能時期</dt>
          <dd>購入後、直ちにご利用いただけます</dd>
          <dt>商品以外の必要料金</dt>
          <dd>インターネット接続料金や通信料金はお客様のご負担となります。それぞれの料金はインターネットブロバイダーまたは携帯電話会社にお問い合わせください。消費税は内税として表示しております。</dd>
          
          <dt>事業内容</dt>
          <dd>
            インターネットを介したコミュニケーションサービスの提供及び運営
          </dd>
          <dt>ポイント単価</dt>
          <dd>1円=0.75pts</dd>
          <dt>返金について</dt>
          <dd>
            ライブコミュニケーションの提供というコンテンツの都合上､購入されたポイントについては一切返金できませんのであらかじめご了承くださいませ｡
          </dd>
        </dl>
      </div>
    </>
  );
};
export default TransactionRuleComponent;